__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@frontend20/main";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@elastic/apm-rum", "5.17.2", () => (() => (__webpack_require__(/*! ../../node_modules/@elastic/apm-rum/dist/es/index.js */ "../../node_modules/@elastic/apm-rum/dist/es/index.js"))), 1);
			register("@moosend/mooskin", "1.1.4", () => (() => (__webpack_require__(/*! ../../node_modules/@moosend/mooskin/lib/index/index.js */ "../../node_modules/@moosend/mooskin/lib/index/index.js"))), 1);
			register("@reduxjs/toolkit", "1.9.7", () => (() => (__webpack_require__(/*! ../../node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js */ "../../node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js"))), 1);
			register("history", "4.10.1", () => (() => (__webpack_require__(/*! ../../node_modules/history/esm/history.js */ "../../node_modules/history/esm/history.js"))), 1);
			register("moment", "2.30.1", () => (__webpack_require__.e("vendors-node_modules_moment_moment_js").then(() => (() => (__webpack_require__(/*! ../../node_modules/moment/moment.js */ "../../node_modules/moment/moment.js"))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e("vendors-node_modules_prop-types_index_js").then(() => (() => (__webpack_require__(/*! ../../node_modules/prop-types/index.js */ "../../node_modules/prop-types/index.js"))))));
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(/*! ../../node_modules/react-dom/index.js */ "../../node_modules/react-dom/index.js"))), 1);
			register("react-is", "16.13.1", () => (__webpack_require__.e("node_modules_react-is_index_js").then(() => (() => (__webpack_require__(/*! ../../node_modules/react-is/index.js */ "../../node_modules/react-is/index.js"))))));
			register("react-is", "17.0.2", () => (__webpack_require__.e("node_modules_react-redux_node_modules_react-is_index_js").then(() => (() => (__webpack_require__(/*! ../../node_modules/react-redux/node_modules/react-is/index.js */ "../../node_modules/react-redux/node_modules/react-is/index.js"))))));
			register("react-query", "3.39.3", () => (__webpack_require__.e("vendors-node_modules_react-query_es_index_js").then(() => (() => (__webpack_require__(/*! ../../node_modules/react-query/es/index.js */ "../../node_modules/react-query/es/index.js"))))));
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(/*! ../../node_modules/react-redux/es/index.js */ "../../node_modules/react-redux/es/index.js"))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(/*! ../../node_modules/react-router-dom/esm/react-router-dom.js */ "../../node_modules/react-router-dom/esm/react-router-dom.js"))), 1);
			register("react-router", "5.3.4", () => (() => (__webpack_require__(/*! ../../node_modules/react-router/esm/react-router.js */ "../../node_modules/react-router/esm/react-router.js"))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(/*! ../../node_modules/react/index.js */ "../../node_modules/react/index.js"))), 1);
			register("redux-saga", "1.4.2", () => (() => (__webpack_require__(/*! ../../node_modules/redux-saga/dist/redux-saga.esm.js */ "../../node_modules/redux-saga/dist/redux-saga.esm.js"))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(/*! ../../node_modules/redux/es/redux.js */ "../../node_modules/redux/es/redux.js"))), 1);
			register("reselect", "4.1.8", () => (() => (__webpack_require__(/*! ../../node_modules/reselect/es/index.js */ "../../node_modules/reselect/es/index.js"))), 1);
			initExternal("webpack/container/reference/accounts");
			initExternal("webpack/container/reference/billing");
			initExternal("webpack/container/reference/campaigns");
			initExternal("webpack/container/reference/core");
			initExternal("webpack/container/reference/customdomains");
			initExternal("webpack/container/reference/dashboards");
			initExternal("webpack/container/reference/entities");
			initExternal("webpack/container/reference/mailinglists");
			initExternal("webpack/container/reference/maindash");
			initExternal("webpack/container/reference/notification");
			initExternal("webpack/container/reference/reports");
			initExternal("webpack/container/reference/topbar");
			initExternal("webpack/container/reference/standalone");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};